import { FC } from 'react';
import { VStack } from '@chakra-ui/react';

import { AdListItem } from './components';
import { CommonAdListProps } from '../../types';

export type AdListProps = CommonAdListProps;

export const AdList: FC<AdListProps> = ({ items, onActionExecuted, showPlatform, tabStatus, hasMemberContract }) => {
  return (
    <VStack align="stretch" spacing={6}>
      {items.map((item) => (
        <AdListItem
          key={item.id}
          item={item}
          onActionExecuted={onActionExecuted}
          showPlatform={showPlatform}
          tabStatus={tabStatus}
          hasMemberContract={hasMemberContract}
        />
      ))}
    </VStack>
  );
};
